import isBlank from 'is-blank'
import createFormModule from '../../utils/createFormModule'
import {
  DEMO_FORM_REQUEST,
  DEMO_FORM_SUCCESS,
  DEMO_FORM_ERROR,
  SET_COMPANY,
  SET_NAME,
  SET_EMAIL,
  SET_PHONE
} from './types'

const formModule = createFormModule({
  resourcesPath: '/inquiries',
  resourcesName: 'inquiry',
  resourcePath: '/inquiries/:inquiryId',
  resourceName: 'inquiry'
})

const REQUIRED_FIELDS = ['name', 'email']

export const state = {
  ...formModule.state,
  request: {
    isLoading: false,
    error: null
  },
  form: {
    id: null,
    company: '',
    name: '',
    email: '',
    phone: ''
  }
}

export const mutations = {
  ...formModule.mutations,
  [DEMO_FORM_REQUEST] (state) {
    state.request.isLoading = true
  },
  [DEMO_FORM_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [DEMO_FORM_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_COMPANY] (state, value) {
    state.form.company = value
  },
  [SET_NAME] (state, value) {
    state.form.name = value
  },
  [SET_EMAIL] (state, value) {
    state.form.email = value
  },
  [SET_PHONE] (state, value) {
    state.form.phone = value
  },
}

export const actions = {
  ...formModule.actions,
  setCompany ({ commit }, value) {
    commit(SET_COMPANY, value)
  },
  setName ({ commit }, value) {
    commit(SET_NAME, value)
  },
  setEmail ({ commit }, value) {
    commit(SET_EMAIL, value)
  },
  setPhone ({ commit }, value) {
    commit(SET_PHONE, value)
  },
  customSubmit ({ commit, dispatch, state }) {
    commit(DEMO_FORM_REQUEST)
    const inquiryId = state.form.id
    const promise = isBlank(inquiryId)
      ? dispatch('create')
      : dispatch('update', { inquiryId })

    return promise
  },
  reset ({ dispatch }) {
    dispatch('setCompany', '')
    dispatch('setName', '')
    dispatch('setEmail', '')
    dispatch('setPhone', '')
  }
}

export const getters = {
  ...formModule.getters,
  isSaveable ({ form }) {
    const blankFields = REQUIRED_FIELDS.filter(field => isBlank(form[field]))
    return blankFields.length <= 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/demoForm/demoForm.js